import { z } from "zod";

// Используется для двух типов атрибутов: AttrTypeName.date, AttrTypeName.dateTime

export const zAttrDatePicker = z.object({
  editor: z.literal("DatePicker"),
});

export type ZAttrDatePicker = z.infer<typeof zAttrDatePicker>;
